<template>
  <q-item class="q-mb-sm">
    <q-item-section>
      <q-item-label
        ><slot>{{ label }}</slot></q-item-label
      >
    </q-item-section>
    <q-item-section side>
      <slot name="side"></slot>
    </q-item-section>
  </q-item>
</template>

<script setup>
defineProps({ label: { type: [String, Number], required: false } });
</script>
